
"use client";
import React from 'react'
import Reveal from "./Reveal";
import Link from 'next/link';

const domains = [
    { name: "Allied Health Sciences", img: "https://cdn.msu.edu.in/msu-reavamp/phd/allied-health-sciences.webp", desc: "Clinical research, rehabilitation & health systems" },
    { name: "Pharmaceutical Sciences", img: "https://cdn.msu.edu.in/msu-reavamp/phd/Pharmaceutical-Sciences.webp", desc: "Drug discovery, pharmacology & pharmaceutical sciences" },
    { name: "Engineering Science & Technology", img: "https://cdn.msu.edu.in/msu-reavamp/phd/engineering-science-technology.webp", desc: "Applied engineering, emerging tech & innovation" },
    { name: "Management", img: "https://cdn.msu.edu.in/msu-reavamp/phd/Management.webp", desc: "Strategy, finance, HR, operations & business research" },
    { name: "Humanities", img: "https://cdn.msu.edu.in/msu-reavamp/phd/Humanities.webp", desc: "Literature, philosophy, social sciences & cultural studies" },
    { name: "Hospitality and Tourism", img: "https://cdn.msu.edu.in/msu-reavamp/phd/Hospitality-and-Tourism.webp", desc: "Travel, hospitality management & sustainable tourism" },
];
const Domains = () => {


    return (
        <section id="domains" className="py-14 md:py-20 bg-[#F8FAFC]">
            <div className="max-w-(--max-page-width) px-(--container-padding) mx-auto ">
                <Reveal className="text-center mb-12">
                    <div className="flex items-center justify-center gap-2 mb-3">
                        <div className="w-8 h-0.5 bg-[#FFA201]" />
                        <span className="text-[#0475B3] text-xs font-black uppercase tracking-widest">Research Domains</span>
                        <div className="w-8 h-0.5 bg-[#FFA201]" />
                    </div>
                    <h2 className="text-4xl font-black text-[#081E2D] mb-3">Where Will You Research?</h2>
                    <p className="text-gray-500 max-w-xl mx-auto text-md">Choose your domain — or blend them. Interdisciplinary research is actively encouraged at MSU.</p>
                </Reveal>

                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {domains.map((d, i) => (
                        <Reveal key={d.name} delay={i * 80}>
                            <div className="group bg-white rounded-sm overflow-hidden border border-gray-100 hover:shadow-xl hover:shadow-blue-50 transition-all duration-400 hover:-translate-y-2 cursor-default">
                                <div className="relative overflow-hidden h-50">
                                    <img src={d.img} alt={d.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                                    <div className="absolute inset-0 bg-linear-to-t from-[#081E2D]/70 to-transparent" />
                                </div>
                                <div className="p-5">
                                    <h3 className="font-black text-[#081E2D] text-lg mb-1.5 group-hover:text-[#0475B3] transition-colors">{d.name}</h3>
                                    <p className="text-gray-500 text-md leading-normal">{d.desc}</p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={200}>
                    <div className="mt-8 bg-linear-to-r from-[#0475B3] to-[#0a5f8f] rounded-md p-6 flex flex-col sm:flex-row items-center justify-between gap-4">
                        <div>
                            <div className="text-[#FFA201] text-xs font-black uppercase tracking-widest mb-1">Cross-domain Research</div>
                            <p className="text-white font-bold text-lg">Interdisciplinary research is encouraged across all domains</p>
                            <p className="text-blue-200 text-md">Combine Management + Technology, or Health Sciences + Humanities</p>
                        </div>
                        <Link
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://application.msu.edu.in/msu-ph-d-application-form"
                            className="shrink-0 bg-white text-[#0475B3] font-black text-sm px-6 py-3 rounded-full hover:bg-blue-50 transition-colors">
                            Apply Now →
                        </Link>
                    </div>
                </Reveal>
            </div>
        </section>
    )
}

export default Domains